module.exports = __webpack_public_path__ + "img/porsche.9dbf760d.webp";